import { useCallback, type ReactNode } from 'react'
import { useTutorial } from '@/contexts/tutorialContext'

interface TutorialSpotProps {
  id: string
  children: ReactNode
  className?: string
}

export default function TutorialSpot({ id, children, className }: TutorialSpotProps) {
  const registerSpot = useTutorial(s => s.registerSpot)
  const unregisterSpot = useTutorial(s => s.unregisterSpot)

  const callbackRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      registerSpot(id, node)
    } else {
      unregisterSpot(id)
    }
  }, [id, registerSpot, unregisterSpot])

  return <div ref={callbackRef} className={className}>{children}</div>
}
